// Mock data service to provide sample data for the application
// This is used when the backend API is not available

// Sample messages for conversations
// Using let instead of const so we can modify the array
let sampleMessages = [
  {
    id: '1',
    body: 'Hello, I had a question about my aftercare instructions.',
    direction: 'inbound',
    from_number: 'whatsapp:+447528191072',
    to_number: 'whatsapp:+15556470633',
    status: 'received',
    created_at: '2025-05-07T08:34:00Z'
  },
  {
    id: '2',
    body: 'Hi there! I\'m happy to help with your aftercare questions. What specifically would you like to know?',
    direction: 'outbound',
    from_number: 'whatsapp:+15556470633',
    to_number: 'whatsapp:+447528191072',
    status: 'delivered',
    created_at: '2025-05-07T08:36:00Z'
  },
  {
    id: '3',
    body: 'I\'m experiencing some discomfort after the procedure. Is that normal?',
    direction: 'inbound',
    from_number: 'whatsapp:+447528191072',
    to_number: 'whatsapp:+15556470633',
    status: 'received',
    created_at: '2025-05-07T08:38:00Z'
  },
  {
    id: '4',
    body: 'Some discomfort is normal for the first 24-48 hours. Are you taking the prescribed medication? If the pain is severe or worsening, please let us know immediately.',
    direction: 'outbound',
    from_number: 'whatsapp:+15556470633',
    to_number: 'whatsapp:+447528191072',
    status: 'delivered',
    created_at: '2025-05-07T08:40:00Z'
  },
  {
    id: '5',
    body: 'I\'ve been taking the medication as directed. The pain is manageable, just wanted to make sure it was normal. Thank you!',
    direction: 'inbound',
    from_number: 'whatsapp:+447528191072',
    to_number: 'whatsapp:+15556470633',
    status: 'received',
    created_at: '2025-05-07T08:42:00Z'
  },
  {
    id: '6',
    body: 'You\'re welcome! That sounds normal. Remember to rest and follow the aftercare instructions. Don\'t hesitate to reach out if you have any other concerns.',
    direction: 'outbound',
    from_number: 'whatsapp:+15556470633',
    to_number: 'whatsapp:+447528191072',
    status: 'delivered',
    created_at: '2025-05-07T08:45:00Z'
  },
  // Second conversation
  {
    id: '7',
    body: 'Hi, I wanted to provide some feedback on my recent visit.',
    direction: 'inbound',
    from_number: 'whatsapp:+447528191072',
    to_number: 'whatsapp:+15556470633',
    status: 'received',
    created_at: '2025-05-07T09:32:00Z'
  },
  {
    id: '8',
    body: 'Hello Samantha, we appreciate your feedback. How was your experience?',
    direction: 'outbound',
    from_number: 'whatsapp:+15556470633',
    to_number: 'whatsapp:+447528191072',
    status: 'delivered',
    created_at: '2025-05-07T09:35:00Z'
  },
  {
    id: '9',
    body: 'My experience was great! Dr. Holmes was very professional and explained everything clearly.',
    direction: 'inbound',
    from_number: 'whatsapp:+447528191072',
    to_number: 'whatsapp:+15556470633',
    status: 'received',
    created_at: '2025-05-07T09:38:00Z'
  }
];

// Mock API functions
export const mockFetchMessages = (phoneNumber = null) => {
  return new Promise((resolve) => {
    // Simulate network delay
    setTimeout(() => {
      if (phoneNumber) {
        // Return messages for a specific conversation
        const filteredMessages = sampleMessages.filter(
          msg => msg.from_number === phoneNumber || msg.to_number === phoneNumber
        );
        resolve(filteredMessages);
      } else {
        // Return all messages
        resolve(sampleMessages);
      }
    }, 500);
  });
};

export const mockSendMessage = (to, body) => {
  return new Promise((resolve) => {
    // Simulate network delay
    setTimeout(() => {
      const newMessage = {
        id: String(Date.now()),
        body,
        direction: 'outbound',
        from_number: 'whatsapp:+15556470633',
        to_number: to,
        status: 'delivered',
        created_at: new Date().toISOString()
      };
      
      // In a real implementation, we would add this to the sampleMessages array
      // For now, just return the new message
      resolve({ success: true, message: newMessage });
    }, 500);
  });
};

export const mockDeleteConversation = (phoneNumber) => {
  return new Promise((resolve) => {
    // Simulate network delay
    setTimeout(() => {
      // Actually filter out messages for this phoneNumber
      const initialLength = sampleMessages.length;
      sampleMessages = sampleMessages.filter(
        msg => msg.from_number !== phoneNumber && msg.to_number !== phoneNumber
      );
      
      const messagesRemoved = initialLength - sampleMessages.length;
      console.log(`Mock deleted ${messagesRemoved} messages for ${phoneNumber}`);
      
      resolve({ success: true, messagesRemoved });
    }, 500);
  });
};

export const mockClearUnreadCounter = () => {
  return new Promise((resolve) => {
    // Simulate network delay
    setTimeout(() => {
      resolve({ success: true });
    }, 500);
  });
};
